import ColorPicker from './ColorPicker'
export default ColorPicker
export * from './ColorPicker'

import type { InlineColorPickerProps } from './InlineColorPicker'
import InlineColorPicker from './InlineColorPicker'
export { InlineColorPicker }
export type { InlineColorPickerProps }
export * from './InlineColorPicker'
import SwatchPicker from './SwatchPicker'
export { SwatchPicker }

export interface ColorPickerProps {
  label?: string
  value: string
  onChange?: (hex: string) => void
}

export interface CoreColorPickerProps {
  label?: string
  value: string
  onChange?: (hex: string) => void
}
